import React from 'react';

import classNames from 'classnames/bind';
import styles from './BottomButton.scss';
const cx = classNames.bind(styles);

const BottomButton = React.memo(
  ({
    type = '',
    msg = '',
    className = [],
    style = {},
    buttonStyle = {},
    onClick,
    children,
  }) => {
    return (
      <div
        className={cx('BottomButton', ...className)}
        style={style}
        onClick={onClick}
      >
        {msg ? <span className="guide-msg">{msg}</span> : null}
        <button type={type} style={buttonStyle}>
          {children}
        </button>
      </div>
    );
  },
);

export default BottomButton;
